module.exports = "/_next/static/images/0fc74a996b207992ca1365a8b48e599e-nubanker-ds@1x.jpg.webp";